/* eslint-disable import/prefer-default-export */
import {ObjectDocument} from "../../../types/pj1dbApiObject";
import {
  BASE_WORLD_LIST_SORT_ORDERS,
  BaseWorldListSortOrderValue,
  OBJECT_LIST_SORT_ORDERS,
  ObjectListSortOrderValue
} from "../../../constants/constants";
import {BaseWorldDocument} from "../../../types/pj1dbApiWorld";

export function sortObjects(objects: ObjectDocument[], order: ObjectListSortOrderValue): ObjectDocument[] {
  const sorts = {
    [OBJECT_LIST_SORT_ORDERS.OBJECT_NAME.value]: (a: ObjectDocument, b: ObjectDocument) => a.attr.original_name.localeCompare(b.attr.original_name),
    [OBJECT_LIST_SORT_ORDERS.PACKAGE_NAME.value]: (a: ObjectDocument, b: ObjectDocument) => a.attr['object-pkg-original-name'].localeCompare(b.attr['object-pkg-original-name']),
    [OBJECT_LIST_SORT_ORDERS.LATEST.value]: (a: ObjectDocument, b: ObjectDocument) => b.attr.inserted - a.attr.inserted,
  } as const;

  return objects.sort(sorts[order]);
}

export function sortBaseWorlds(baseWorlds: BaseWorldDocument[], order: BaseWorldListSortOrderValue): BaseWorldDocument[] {
  const sorts = {
    [BASE_WORLD_LIST_SORT_ORDERS.BASE_WORLD_NAME.value]: (a: BaseWorldDocument, b: BaseWorldDocument) => a.attr['name-jp'].localeCompare(b.attr['name-jp']),
    [BASE_WORLD_LIST_SORT_ORDERS.LATEST.value]: (a: BaseWorldDocument, b: BaseWorldDocument) => b.attr.inserted - a.attr.inserted,
  } as const;

  return baseWorlds.sort(sorts[order]);
}
